// @flow
export const DOG_BARK = 'DOG_BARK';
export const GLASS_BREAK = 'GLASS_BREAK';
export const SENSE = 'SENSE';
export const SMOKE_CO = 'SMOKE_CO';
export const VALID_SENSOR_TYPES = [DOG_BARK, GLASS_BREAK, SMOKE_CO];



// WEBPACK FOOTER //
// ./src/core/constants/products-sense.js